function HeroVisual({ badgeTitle, years, img, imgAlt }) {
  return (
    <div className="hero-visual">
      <div className="photo-frame">
        <div className="photo-border">
          <div className="photo-inner">
            <img src={img} alt={imgAlt} />
          </div>
        </div>
        <div className="photo-corner tl"></div>
        <div className="photo-corner tr"></div>
        <div className="photo-corner bl"></div>
        <div className="photo-corner br"></div>
        <div clasclassNames="photo-badge">
          <span className="photo-badge-icon">⭐</span>
          <div>
            <div className="photo-badge-title">{badgeTitle}</div>
            <div className="photo-badge-sub">{years} </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroVisual;
